export const FETCH_NEXT_PRICE = 'fetchNextPrice'
